import { render } from "./BlogPost.vue?vue&type=template&id=2e5d932a&scoped=true"
import script from "./BlogPost.vue?vue&type=script&lang=js"
export * from "./BlogPost.vue?vue&type=script&lang=js"

import "./BlogPost.vue?vue&type=style&index=0&id=2e5d932a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5d932a"]])

export default __exports__